import { render } from "./SmsSetupView.vue?vue&type=template&id=440d9c6b"
import script from "./SmsSetupView.vue?vue&type=script&lang=js"
export * from "./SmsSetupView.vue?vue&type=script&lang=js"

import exportComponent from "G:\\deploy\\cfan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__